// src/components/common/Button.js
import React from 'react';

function Button({ children, className = '', variant = 'primary', ...props }) {
  const base = "font-montserrat text-lg px-8 py-4 rounded-full transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";

  const variants = {
    primary: "bg-primary text-cream hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/20 active:scale-98",
    outline: "border-2 border-primary text-primary hover:bg-primary/10 hover:shadow-md",
    eco: "bg-eco-green text-white hover:bg-eco-green/90 hover:shadow-xl hover:shadow-eco-green/20",
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;